<template>
    <div class="">
        <div class="right-side-bar-main-sec">
            <div class="section-listing-page">
                <div  class="listing-mobile-page">
                    <div class="mobile-home-page">
                        <div class="mobile-exch-main-box">
                            <div v-for="(item, index) in staticAndHomeCasinoGames" :key="index"
                                class="exch-coupon-card" @click="loadGame(item)" :class="{ 'static-cls': item?.catSlug === 'static-games' }">
                                <img  loading="lazy" :src="item?.image || item?.imgSrc" @error="getDefaultImage($event)" :alt="item.game_name" />
                            </div>
                        </div>
                    </div>
                </div>

                <!-- /cricket/ -->
                <section class="bet-details-sec" v-for="(sport,sIndex) in inplayMatches" :key="sIndex">
                    <div class="bet-details-header" v-if="sport.matches.length">
                        <div class="row">
                            <div class="col-12 col-md-6 d-flex justify-content-between align-items-center">
                                <div class="list-sport-title">
                                    <img loading="lazy" :src="getSportImage(inplayMatches[sIndex]?.matches?.[0]?.sport_id)"
                                        alt="tennis icon" />
                                        <span>{{ sIndex == 'soccer' ? $t('football','Football') : $t(sIndex?.toLowerCase()?.replaceAll(' ','-'),sIndex )}}</span>
                                    </div>
                                    <ul class="live_virtual">
                                        <li><input type="checkbox" value="Order one" class="filter-checkbox" @change="changeFilterKey('live', sport.filterKey)"><label>{{$t('live','LIVE')}}</label></li>
                                        <li><input type="checkbox" value="Order Two" class="filter-checkbox" @change="changeFilterKey('virtual',sport.filterKey)"><label>{{$t('virtual','VIRTUAL')}}</label></li>
                                    </ul>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="add-even-sec">
                                    <div class="stack-1">
                                        <span>1</span>
                                    </div>
                                    <div class="stack-1">
                                        <span>X</span>
                                    </div>
                                    <div class="stack-1">
                                        <span>2</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <SportItem v-if="sport.matches.length" :sportsData="filterMatches(sport)"/>
                </section>
                <div id="casinosection"></div>
                <section v-if="showCasino"  class="exchange-game-conetent-sec-in-mobile">
                    <div class="bet-details-header">
                        <div class="row">
                            <div class="col-6">
                                <div class="list-sport-title">
                                    <img loading="lazy" src="@/assets/images/casino-title-menu.png" alt="casino-menu" />
                                    <span>{{$t('casino-provider','Casino Provider')}}</span>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="add-even-sec">
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="home-casino-img" v-if="casinoProviders" >
                        <div v-for="(item, index) in casinoProviders.games" class="home-star-model-img" :key="index" >
                            <div class="casinoicons" @click=" this.$router.push({name: 'Games', params: {type: 'casino'}, query: {providerId: item.provider_id}});">
                                <img  loading="lazy" :src="item?.image || item?.imgSrc" @error="getDefaultImage($event)" :alt="item.game_name" />
                            </div>
                        </div>
                    </div>
                </section>
                <div ref="upcomigMatch" v-if="$route.path!='/inplay'"></div>
                <Banner />
                <section class="upcoming-section" v-if="$route.path!='/inplay'">
                    <div class="bet-details-header">
                        <div class="row">
                            <div class="col-12">
                                <div class="upcomingmatch-title">
                                    <img loading="lazy" src="@/assets/images/menu-upcoming.png" alt="menu-upcoming" />
                                    <span>{{ $t('upcoming-events','Upcoming Events') }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section class="bet-details-sec" v-for="(sport, sIndex) in upcomingMatches" :key="sIndex">
                        <div class="bet-details-header" v-if="sport.matches.length > 0">
                            <div class="row">
                                <div class="col-12 col-md-6 d-flex justify-content-between align-items-center">
                                    <div class="list-sport-title">
                                        <img loading="lazy" :src="getSportImage(upcomingMatches[sIndex]?.matches?.[0]?.sport_id)"
                                            alt="tennis icon" />
                                            <span>{{ sIndex == 'soccer' ? $t('football','Football') : $t(sIndex?.toLowerCase()?.replaceAll(' ','-'),sIndex ) }}</span>
                                        </div>
                                    <ul class="live_virtual">
                                        <li><input type="checkbox" value="Order one" class="filter-checkbox" @change="changeFilterKey('live', sport.filterKey)"><label>{{$t('live','LIVE')}}</label></li>
                                        <li><input type="checkbox" value="Order Two" class="filter-checkbox" @change="changeFilterKey('virtual',sport.filterKey)"><label>{{$t('virtual','VIRTUAL')}}</label></li>
                                    </ul>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="add-even-sec">
                                        <div class="stack-1">
                                            <span>1</span>
                                        </div>
                                        <div class="stack-1">
                                            <span>X</span>
                                        </div>
                                        <div class="stack-1">
                                            <span>2</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <SportItem v-if="sport.matches.length > 0" :sportsData="filterMatches(sport)" :type="'HOME'"/>
                    </section>
                </section>
            </div>
        </div>
    </div>
</template>

<script>

import { defineAsyncComponent } from 'vue';
import { ref } from 'vue';
import socketService from "../socket/sport-socket-service";
import {checkEventManageforSports, checkInEventMangeForSection, checkForLockedMatches} from '@/shared/services/eventLocks.js';
import loadCasinoGame from '@/shared/services/casinoGamesHandler.js';

export default {
    name: 'Home',
    components: {
        Banner: defineAsyncComponent(() =>
            import('@/shared/components/banner/Banner.vue')
        ),
        SportItem: defineAsyncComponent(() =>
            import('@/modules/sports/components/SportItem.vue')
        ),
        NoDataFound: defineAsyncComponent(() =>
            import('@/shared/components/no-data/NoDataFound.vue')
        )
    },
    data() {
        return {
            staticGames: [
                {
                    game_name: 'Aviator',
                    slug: 'aviator',
                    catSlug: 'static-games',
                    imgSrc: require('@/assets/images/aviator_compressed.gif')
                },
                {
                    game_name: 'Mines',
                    slug: 'mines',
                    catSlug: 'static-games',
                    imgSrc: require('@/assets/images/mines_compressed.gif')
                },
                {
                    game_name: 'Fun Games',
                    slug: 'fun-games',
                    catSlug: 'static-games',
                    imgSrc: require('@/assets/images/fungames_compressed.gif')
                },
                {
                    game_name: 'Color Pridiction',
                    slug: 'colour-game',
                    catSlug: 'static-games',
                    imgSrc: require('@/assets/images/color-pridiction-compressed.gif')
                }
            ],
            loading: false,
            inplayMarketOdds: {},
            inplayMatches: {},
            socketEmitterList: [],
            allData: {},
            favouriteList: this.$store.getters.favouriteGames,
            observer: null,
            upcomingMatchesData:[],
            upcomingMatches: {},
            defaultGameImage: require('@/assets/images/reddybook-not-image-found-by-default-img.webp'),
            filterKey: [],
            homeSectionMenus: null,
            casinoProviders: null,
            showCasino:false,
            CasinoObserver:null
        }
    },
    computed:{
        staticAndHomeCasinoGames() {
            return [...(this.staticGames || []), ...(this.homeSectionMenus?.games || [])];
        },
        eventManage(){
            return this.$store?.getters?.eventManage;
        }
    },
    mounted() {
        this.getInplayMatches();
        this.getCasinoGamesServiceCall();
        this.observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting && !this.upcomingMatchesData?.length) {
                    this.observer.unobserve(entry.target);
                    this.getUpcomingMatches('upcoming');
                }
            });
        });
    },
    methods: {
        getCasinoGamesServiceCall() {
        const casinoData = this.$store?.getters?.gamesData || {};
        this.gamesData = casinoData;
        if (this.$auth.status) {
            checkInEventMangeForSection(this.gamesData);
            this.$store.dispatch('setGamesData', this.gamesData);
        }
        const sections = this.gamesData?.sections || [];
        this.homeSectionMenus = sections.find(item => item.slug === 'home-casino')
        this.casinoProviders = sections.find(item => item.slug === 'providers') || null; 
        this.$nextTick(() => {
            let targetElement = document.getElementById('casinosection');
            if (targetElement && !this.CasinoObserver) {
                this.CasinoObserver = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            this.observer.unobserve(entry.target);
                            this.showCasino = true;
                            this.CasinoObserver = null;
                        }
                    });
                });
                this.CasinoObserver.observe(targetElement);
            }
        });
    },
        getDefaultImage(event) {
            event.target.src = "/path/to/default-image.jpg"; 
        },
        changeFilterKey(type, filterKey) {
            const index = filterKey.indexOf(type);
            index > -1 ? filterKey.splice(index, 1) : filterKey.push(type);
        },
        filterMatches(data) {
            const { matches, filterKey } = data;
            
            if (!filterKey || !Array.isArray(filterKey) || filterKey.length === 0) {
                return matches;
            }
            return matches.filter(item => { 
                const isLive = !item.is_exclusive;
                const isVirtual = item.is_exclusive;

                if (filterKey.includes('live') && filterKey.includes('virtual')) {
                    return isLive || isVirtual;
                }
                if (filterKey.includes('live')) {
                    return isLive && !isVirtual;
                }
                if (filterKey.includes('virtual')) {
                    return isVirtual;
                }
                return true;
            });
        },
        getUpcomingMatches(type){
            this.$store.dispatch('setGlobalLoader',true);
            this.$apiCall('get', 'GET_UPCOMING_SPORTS', null, 'sports', { day: type }).then(response => {
                this.$store.dispatch('setGlobalLoader',false);
                if (response && response.status == 200) {
                    var upcoming_match_list = response.data.data.sort().reverse()
                    this.upcomingMatches['cricket'] = { matches: [], filterKey: [] };
                    this.upcomingMatches['football'] = { matches: [], filterKey: [] };
                    this.upcomingMatches['tennis'] = { matches: [], filterKey: [] };           
                    let lockedMatchIds = [];
                    let lockedLeagueIds = [];
                    if(this.$auth.status && this.eventManage) {
                        lockedMatchIds = this.eventManage.find(item => item.type == 'match');
                        lockedLeagueIds = this.eventManage.find(item => item.type == 'league');

                        lockedMatchIds = lockedMatchIds && lockedMatchIds.type_id !== null ? lockedMatchIds.type_id.split(',') : [];
                        lockedLeagueIds = lockedLeagueIds && lockedLeagueIds.type_id !== null ? lockedLeagueIds.type_id.split(',') : []
                    }            
                    for (var i = 0; i < upcoming_match_list.length; i++) {
                        if(checkEventManageforSports(upcoming_match_list[i].sport_id) && checkForLockedMatches(upcoming_match_list[i].matchId, upcoming_match_list[i].league_id, lockedMatchIds, lockedLeagueIds)) {
                            upcoming_match_list[i]['favourite']= this.favouriteList?.includes(parseInt(upcoming_match_list[i].event_id))                    
                            let sportKey;
                            if (upcoming_match_list[i].sport_id == 4) {
                                sportKey = 'cricket';
                            } else if (upcoming_match_list[i].sport_id == 1) {
                                sportKey = 'football';
                            } else if (upcoming_match_list[i].sport_id == 2) {
                                sportKey = 'tennis';
                            } else {
                                sportKey = upcoming_match_list[i].sport_name;
                            }
                            if (!this.upcomingMatches[sportKey]) {
                                this.upcomingMatches[sportKey] = { matches: [], filterKey: [] };
                            }
                            this.upcomingMatches[sportKey].matches.push(upcoming_match_list[i]);
                        }
                    }   
                                     
                }
            }).catch(error => {
                this.$store.dispatch('setGlobalLoader',false);
                if (error) {
                    console.log("Error : ", error);
                }
            });
        },
        getInplayMatches() {
            this.loading = true;
            this.$apiCall('get', 'INPLAY_MATCHES_LIST', null, 'sports').then(response => {
                this.loading = false;
                if (response && response.status == 200) {
                    this.allData = response.data.data
                    var inplay_match_list = response.data.data.inplay;
                    this.setMatches(inplay_match_list);
                    let targetElement = this.$refs.upcomigMatch;
                    if (targetElement) {
                        this.observer.observe(targetElement);
                    }
                }
            }).catch(error => {
                this.loading = false;
                if (error) {
                    console.log("Error : ", error);
                }
            });
        },
        setMatches(data) {           
            var inplay_match_list = data;   
            this.inplayMatches['cricket'] = { matches: [], filterKey: [] };
            this.inplayMatches['football'] = { matches: [], filterKey: [] };
            this.inplayMatches['tennis'] = { matches: [], filterKey: [] };           
            let lockedMatchIds = [];
            let lockedLeagueIds = [];
            if(this.$auth.status && this.eventManage) {
                lockedMatchIds = this.eventManage.find(item => item.type == 'match');
                lockedLeagueIds = this.eventManage.find(item => item.type == 'league');

                lockedMatchIds = lockedMatchIds && lockedMatchIds.type_id !== null ? lockedMatchIds.type_id.split(',') : [];
                lockedLeagueIds = lockedLeagueIds && lockedLeagueIds.type_id !== null ? lockedLeagueIds.type_id.split(',') : []
            }            
            for (var i = 0; i < inplay_match_list.length; i++) {
                if(checkEventManageforSports(inplay_match_list[i].sport_id) && checkForLockedMatches(inplay_match_list[i].matchId, inplay_match_list[i].league_id, lockedMatchIds, lockedLeagueIds)) {
                    inplay_match_list[i]['favourite']= this.favouriteList?.includes(parseInt(inplay_match_list[i].event_id))                    
                    let sportKey;
                    if (inplay_match_list[i].sport_id == 4) {
                        sportKey = 'cricket';
                    } else if (inplay_match_list[i].sport_id == 1) {
                        sportKey = 'football';
                    } else if (inplay_match_list[i].sport_id == 2) {
                        sportKey = 'tennis';
                    } else {
                        sportKey = inplay_match_list[i].sport_name;
                    }
                    if (!this.inplayMatches[sportKey]) {
                        this.inplayMatches[sportKey] = { matches: [], filterKey: [] };
                    }
                    this.inplayMatches[sportKey].matches.push(inplay_match_list[i]);
                }
            }
        },
        loadGame(game) {
            if(game.catSlug == 'static-games') {
                this.$router.push({name: 'Games', params: {type: 'casino'}, query: {menuName: game.slug}});
                return
            }
            if(!this.$auth.status) {
                this.$helper.showLogin();
                return;
            }
            loadCasinoGame.loadGame(game, this.$auth.user);
        },
        getSportImage(sportId) {
            const imageMap = {
                4: require("@/assets/images/sports-cricket.png"),
                1: require("@/assets/images/sports-soccer.png"),
                2: require("@/assets/images/sports-tennis.png"),
                1477: require("@/assets/images/sports-rugby-league.png"),
                6: require("@/assets/images/sports-boxing.png"),
                5: require("@/assets/images/sports-rugby-union.png"),
                3: require("@/assets/images/sports-golf.png"),
                27454571: require("@/assets/images/sports-esports.png"),
                2152880: require("@/assets/images/sports-gaelic-football.png"),
                998917: require("@/assets/images/sports-volleyball.png"),
                7524: require("@/assets/images/sports-ice-hockey.png"),
                7522: require("@/assets/images/sports-basketball.png"),
                7511: require("@/assets/images/sports-baseball.png"),
                6423: require("@/assets/images/sports-american-football.png"),
                6422: require("@/assets/images/sports-snooker.png"),
                11: require("@/assets/images/sports-cycling.png"),
                8: require("@/assets/images/sports-motor-sport.png"),
                2378961: require("@/assets/images/sports-politics.png"),
                468328: require("@/assets/images/sports-handball.png"),
                61420: require("@/assets/images/sports-australian-rules.png"),
                3503: require("@/assets/images/sports-darts.png"),
                10: require("@/assets/images/sports-special-bets.png"),
                26420387: require("@/assets/images/sports-mixed-martial-arts.png"),
                4339: require("@/assets/images/sports-greyhound-racing.png"),
                7: require("@/assets/images/sports-horse-racing.png"),
                4343: require("@/assets/images/fifa-cup-winner.png"),
                4344: require("@/assets/images/winner-cup.png"),
                4345: require("@/assets/images/election.png"),
                27454572: require("@/assets/images/kabaddi.png"),
                27454574: require("@/assets/images/table-tennis.png"),
            };
            return imageMap[sportId] || require("@/assets/images/sports-no.png");
        },
        getDefaultImage(event) {
            event.target.src = this.defaultGameImage;
        }
    },
    setup() {
        const showButton = ref(true);
        const toggleButton = () => {
            showButton.value = !showButton.value;
        };
        return {
            showButton,
            toggleButton
        };
    },
    beforeUnmount() {
        socketService.off('App\\\\Events\\\\MarketBroadcastData');
        socketService.emit("leave", this.socketEmitterList);
    },

}
</script>

